<template>
  <div>
    <div v-if="isLoading">
      <br /><br /><br /><br />
      <br /><br /><br /><br />
      <v-progress-circular :size="200" :width="7" color="blue" indeterminate
        ><b></b
      ></v-progress-circular>
    </div>
    <div v-if="!isLoading">
      <v-container id="landingPageContainer" fluid class=" lighten-5 pt-0">
        <v-row>
          <v-col cols="4">
            <v-row>
              <v-col>
                <v-autocomplete
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  filled
                  solo
                  dense
                  :items="summaryData.allNumbersForAccount"
                  v-model="searchValue"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item class="medium-font">
                      <router-link :to="{ path: 'mobile/' + item }">{{
                        item
                      }}</router-link>
                    </v-list-item>
                  </template>
                </v-autocomplete>
                <v-card id="summaryCard" class="d-flex pa-2" ripple>
                  <v-col class="text-left" cols="6">
                    <div class="font-weight-black mb-4">
                      <tool-tip
                        text="Current OOB Spend"
                        hoverText="Estimated out of bundle spend since the last invoice date, excluding any monthly service charges"
                        position="top"
                        iconName="mdi-information-outline"
                        iconSize=20
                      >
                      </tool-tip>
                    </div>

                    <p>
                  
                        £{{ this.currentSpend.toFixed(2) }}
                    </p>

                    <div class="font-weight-black mb-4">
                      <tool-tip
                        text="Current Data Usage"
                        hoverText="Estimated data usage since the last invoice date"
                        position="top"
                        iconName="mdi-information-outline"
                        iconSize=20
                      >
                      </tool-tip>
                    </div>

                    <p class="font-weight-medium mb-0">

                        {{ this.currentDataUsage }} GB
                 
                    </p>
                  </v-col>
                  <v-divider inset vertical></v-divider>
                  <v-col class="text-right" cols="6">
                    <p >
                      <router-link :to="linkToLastInvoiceNumber"
                        >Last Invoice (inc VAT)
                      </router-link>
                    </p>
                    <p
                      class="font-weight-medium "
                      v-if="lastInvoiceCharge.length > 4"
                    >
           
                        £{{ lastInvoiceCharge }}
              
                    </p>
                    <p class="font-weight-medium ">
                
                        {{ lastInvoiceDateString }}
                    </p>
                    <p class="font-weight-medium mb-0">
                      <router-link to="/table/invoice_line"
                        ><v-btn
                          outlined
                          small
                          color="maintel-dark-green"
                          to="/table/aggregate_invoice_line"
                          class="text-none"
                        >
                          <b>Invoices</b></v-btn
                        >
                      </router-link>
                    </p>
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card id="donutSpendCard" ripple class="pb-1">
                  <p class="font-weight-black pt-5 mb-3">
                    <router-link to="/table/cdr_summary_record" class="is-link">
                      <tool-tip
                        text="Out Of Bundle Spend By Classification"
                        hoverText="Estimated out of bundle spend since the last invoice date, excluding any monthly service charges"
                        position="top"
                        iconName="mdi-information-outline"
                        isLink="true"
                      >
                      </tool-tip>
                    </router-link>
                  </p>
                  <v-divider></v-divider>
                  <div class="d-flex pa-3 justify-center">
                    <apexchart
                      type="donut"
                      width="386.5"
                      :options="chartOptions"
                      :series="series"
                    ></apexchart>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-card id="buttonCard" ripple>
                  <v-container class="d-flex mb-0 pb-0">
                    <v-col class="text-left" cols="6">
                      <p class="font-weight-medium mb-0">
                        <v-btn
                          outlined
                          small
                          color="maintel-dark-green"
                          class="text-none"
                          to="/table/service_report_line"
                          block
                          ><b>Subscribers Services</b></v-btn
                        >
                      </p>
                    </v-col>
                    <v-col class="text-right" cols="6">
                      <p class="font-weight-medium mb-0">
                        <v-btn
                          outlined
                          small
                          color="maintel-dark-green"
                          class="text-none"
                          to="/table/diary_events_line"
                          block
                          ><b>Service Change Log</b></v-btn
                        >
                      </p>
                    </v-col>
                  </v-container>
                  <v-container class="d-flex mb-0 pb-0 pt-0">
                    <v-col class="text-left pt-0" cols="6">
                      <p class="font-weight-medium mb-0">
                        <v-btn
                          outlined
                          small
                          color="maintel-dark-green"
                          class="text-none"
                          to="/table/non_cc_bar_line"
                          block
                          ><b
                            >Service Bars ({{
                              summaryData.numberOfNonCCBars
                            }})</b
                          ></v-btn
                        >
                      </p>
                    </v-col>
                    <v-col class="text-left pt-0" cols="6">
                      <p class="font-weight-medium mb-0">
                        <v-btn
                          outlined
                          small
                          color="maintel-dark-green"
                          class="text-none"
                          to="/table/service_response_line"

                          
                          block
                          ><b
                            >Self Serve Log</b
                          ></v-btn
                        >
                      </p>
                    </v-col>

                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="8">
            <v-row>
              <v-col>
                <v-card id="topNumberCard" ripple>
                  <v-list-item>
                    <v-list-item-content class="pb-0">
                      <v-list-item-title
                        class="text-h7 text-center font-weight-black"
                      >
                        <tool-tip
                          text="Top Numbers By Current Out Of Bundle Spend"
                          hoverText="Estimated out of bundle spend since the last invoice date, excluding any monthly service charges"
                          position="top"
                          iconName="mdi-information-outline"
                          class="mb-2"
                        >
                        </tool-tip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left medium-font font-weight-light">
                            Mobile Number
                          </th>
                          <th class="text-left medium-font font-weight-light">
                            Spend
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in summaryData.topFiveNumbers"
                          :key="index"
                        >
                          <td width="50%" class="text-left">
                            <router-link
                              :to="{
                                path: 'mobile/' + item.networkSerialNumber,
                              }"
                              >{{ item.networkSerialNumber }}</router-link
                            >
                          </td>
                          <td width="50%" class="text-left">
                            <span v-if="item.networkSerialNumber.length > 1"
                              >£{{ item.sumSpBilledCallPrice.toFixed(2) }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>

                  <v-container class="d-flex pb-0 pt-4">
                    <v-row>
                      <v-col>
                        <p class="font-weight-medium text-left">
                          <v-btn
                            outlined
                            small
                            color="maintel-dark-green"
                            class="text-none"
                            to="/table/cdr_summary_record"
                          >
                            <b>Mobile Spend</b></v-btn
                          >
                        </p>
                      </v-col>
                      <v-col>
                        <p class="font-weight-medium text-right">
                          <v-btn
                            outlined
                            small
                            color="maintel-dark-green"
                            class="text-none"
                            to="/table/data_report_line"
                            ><b
                              >Subscriptions ({{ totalMobileNumbers }})</b
                            ></v-btn
                          >
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-card id="topUsageCard" ripple>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-h7 font-weight-medium"
                      >
                        <div class="d-flex pa-2 pb-0 pt-0 pl-0">
                          <v-col cols="5" class="pt-1 pl-0 pb-0 text-left">
                            <div class="d-flex grey-text">Top Bundle Usage</div>
                          </v-col>

                          <v-col cols="7" class="pt-0 pb-0 ml-5 text-right">
                            <v-btn
                              outlined
                              small
                              color="accent"
                              class="text-none"
                              @click="showingExpired = !showingExpired"
                            >
                              <b>Including Expired Bundles</b>
                              &nbsp;&nbsp;

                              <v-icon left v-if="showingExpired">
                                mdi-check
                              </v-icon>
                              <v-icon left v-if="!showingExpired">
                                mdi-close
                              </v-icon>
                            </v-btn>
                            &nbsp;&nbsp;
                            <v-btn
                              outlined
                              small
                              color="accent"
                              class="text-none"
                              @click="includingMax = !includingMax"
                            >
                              <b>Including Bundles At Max Usage</b>
                              &nbsp;&nbsp;

                              <v-icon left v-if="includingMax">
                                mdi-check
                              </v-icon>
                              <v-icon left v-if="!includingMax">
                                mdi-close
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left medium-font font-weight-light">
                            Mobile Number
                          </th>
                          <th class="text-left medium-font font-weight-light">
                            Bundle
                          </th>
                          <th class="text-left medium-font font-weight-light">
                            Usage
                          </th>
                          <th class="text-left medium-font font-weight-light">
                            Expires
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in visibleTopBundleUsage"
                          :key="index"
                        >
                          <td width="25%" class="text-left">
                            <router-link
                              v-show="item.mobilePhoneNumber != null"
                              :to="{ path: 'mobile/' + item.mobilePhoneNumber }"
                              >{{ item.mobilePhoneNumber }}
                            </router-link>

                            <span
                              v-show="
                                item.mobilePhoneNumber == null && index == 0
                              "
                            >
                              No Bundles Found Matching Criteria
                            </span>
                          </td>
                          <td width="25%" class="text-left">
                            <span v-show="item.mobilePhoneNumber != null"
                              >{{ item.bundleCode }} ({{
                                item.bundleDescription
                              }})</span
                            >
                          </td>
                          <td width="25%" class="text-left">
                            <span v-show="item.mobilePhoneNumber != null"
                              >{{
                                (100 - item.bundleNotUsedPercentage).toFixed(2)
                              }}%</span
                            >
                          </td>
                          <td width="25%" class="text-left">
                            <span v-if="item.bundleExpiryDate != null">{{
                              buildDateString(
                                item.bundleExpiryDate.dayOfMonth,
                                item.bundleExpiryDate.monthValue,
                                item.bundleExpiryDate.year
                              )
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>

                  <v-container class="pb-3">
                    <v-row>
                      <v-col class="text-left mt-1" cols="6">
                        <span>
                          Max Usage Bundles&nbsp;
                          <v-chip color="#AEC6CF" label small>
                            <b>{{
                              summaryData.numberOfBundlesAtOrExceedingMaxUsage
                            }}</b>
                          </v-chip>
                        </span>
                      </v-col>
                      <v-col class="text-right" cols="6">
                        <span class="font-weight-medium">
                          <v-btn
                            outlined
                            small
                            color="maintel-dark-green"
                            class="text-none"
                            to="/table/aggregate_bundle_line"
                            ><b>Bundle Utilisation</b></v-btn
                          >
                        </span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mb-1" v-if="false">
          <v-col>
            <v-card ripple id="requestsCard" height="110px">
              <div>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="text-h7 font-weight-black">
                      <div class="d-flex pa-2 pb-0 pt-0 pl-0">
                        <v-col cols="6" class="pt-1 pl-0 pb-0 text-left">
                          <div class="pt-small">Service Requests</div>
                        </v-col>
                        <v-col cols="6" class="pt-0 pb-0 ml-5 text-right">
                          <v-btn outlined small color="maintel-dark-green" class="text-none"
                            ><b>Service Requests</b></v-btn
                          >
                        </v-col>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-row
                  class="mt-0 pb-0"
                  v-for="(service, index) in summaryData.recentRequests"
                  :key="index"
                >
                  <v-col
                    class="text-left"
                    cols="10"
                    v-bind:class="{
                      'pb-0': index == summaryData.recentRequests.length - 1,
                    }"
                  >
                    <v-container v-if="index > 0" class="pt-0 pb-0">
                      <v-divider></v-divider>
                    </v-container>
                    <p class="font-weight-black ml-4 pt-1">
                      <v-chip
                        outlined
                        label
                        small
                        color="blue"
                        text-color="black"
                        >SPEND CAP INCREASE</v-chip
                      >

                      &nbsp;&nbsp;&nbsp;&nbsp;

                      <v-chip
                        outlined
                        label
                        small
                        color="#ff8c00"
                        text-color="black"
                      >
                        21/11/2021 15:20PM &nbsp;
                        <v-icon small aria-hidden="false">
                          mdi-calendar-clock
                        </v-icon>
                      </v-chip>

                      &nbsp;&nbsp;&nbsp;&nbsp;

                      <v-chip
                        outlined
                        label
                        small
                        color="maintel-dark-green"
                        text-color="black"
                        >INCREASE SPEND CAP FOR 07466 565 460</v-chip
                      >
                    </p>
                  </v-col>
                  <v-col
                    class="text-right"
                    cols="2"
                    v-bind:class="{
                      'pb-0': index == summaryData.recentRequests.length - 1,
                    }"
                  >
                    <p class="font-weight-medium grey-text mr-4">
                      <v-btn
                        outlined
                        small
                        color="maintel-dark-green"
                        class="text-none"
                        to="/landing"
                        ><b>View Details</b></v-btn
                      >
                    </p>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import ToolTip from "./ToolTip.vue";

export default {
  components: {
    apexchart: VueApexCharts,
    ToolTip,
  },
  data() {
    return {
      accountMobileNumbers: [],
      toggleText: "Exclude Bundles At Max Usage",
      toggleExpiryText: "Include Expired Bundles",
      onMobilePanel: true,
      showingExpired: false,
      includingMax: true,
      isLoading: true,
      searchValue: "",
      linkToLastInvoiceNumber: "",
      lastInvoiceDateString: "",
      totalMobileNumbers: 0,
      currentSpend: 0,
      lastInvoiceCharge: "0.00",
      visibleTopBundleUsage: [],
      numberOfVisibleBundles: 0,
      currenDataUsage: 0,
      summaryData: {
        billedCallPriceByClassType: {},
        lastInvoice: {},
        lastUpdatedDate: {},
        lastUpdatedTime: {},
        numberOfCCBars: 0,
        numberOfNonCCBars: 0,
        topFiveBundleUsage: [],
        topFiveNumbers: [],
      },
      series: [],
      chartOptions: {
        chart: {
          events: {
            dataPointSelection: function (event, chartContext, config) {
              var link = window.location.href;
              var linkBuilt =
                link.substring(0, link.indexOf("landing")) +
                "table/cdr_summary_record/" +
                encodeURIComponent(
                  config.w.config.labels[config.selectedDataPoints[0]]
                );
              window.location.href = linkBuilt;
            },
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: "OOB Spend",
                  fontSize: "18px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  color: "#373d3f",
                  formatter: function (w) {
                    var totalValue = w.globals.seriesTotals
                      .reduce((a, b) => {
                        return a + b;
                      }, 0)
                      .toLocaleString();
                    return "£" + totalValue;
                  },
                },
              },
            },
          },
        },
        colors : ["#64c2c9", "#f64e60", "#e57e0f", "#dfbd03", "#5cb85c", "#82A62C", "#8e5e98", "#FF8200", "#3F6FFF", "#AE14CE", "#57aefe", "#B2D953"],

        stroke: {
          show: true,
          colors: ["black"],
          width: 2,
        },
        legend: {
          show: false,
        },
        labels: [],
        tooltip: {
          y: {
            formatter: function (value) {
              return "£" + value.toFixed(2);
            },
          },
        },
      },
    };
  },
  watch: {
    showingExpired: function (newVal, oldVal) {
      this.toggleBundleTable();
    },
    includingMax: function (newVal, oldVal) {
      this.toggleBundleTable();
    },
  },
  methods: {
    toggleBundleTable() {
      this.numberOfVisibleBundles = 0;

      if (this.showingExpired && !this.includingMax) {
        this.visibleTopBundleUsage =
          this.summaryData.topFiveBundleUsageNonMaxIncludeExpired;
      } else if (!this.includingMax && !this.showingExpired) {
        this.visibleTopBundleUsage = this.summaryData.topFiveBundleUsageNonMax;
      } else if (this.includingMax && this.showingExpired) {
        this.visibleTopBundleUsage =
          this.summaryData.topFiveBundleUsageIncludeExpired;
        this.showingExpired = true;
      } else if (this.includingMax && !this.showingExpired) {
        this.visibleTopBundleUsage = this.summaryData.topFiveBundleUsage;
        this.showingExpired = false;
      }

      for (var bundle of this.visibleTopBundleUsage) {
        if (bundle.mobilePhoneNumber != null) {
          this.numberOfVisibleBundles += 1;
        }
      }
    },
    buildDateString(day, month, year) {
      var dayString = "" + day;
      var monthString = "" + month;

      if (dayString.length == 1) {
        dayString = "0" + dayString;
      }

      if (monthString.length == 1) {
        monthString = "0" + monthString;
      }

      return dayString + "/" + monthString + "/" + year;
    },
    getDashboard() {
      axios
        .get("/api/mbe/landing-dash")
        .then((response) => {
          this.summaryData = response.data;
          this.visibleTopBundleUsage = this.summaryData.topFiveBundleUsage;

          for (var bundle of this.visibleTopBundleUsage) {
            if (bundle.mobilePhoneNumber != null) {
              this.numberOfVisibleBundles += 1;
            }
          }

          this.currentDataUsage = (
            this.summaryData.currentDataUsage /
            1024 /
            1024
          ).toFixed(2);

          this.totalMobileNumbers =
            this.summaryData.allNumbersForAccount.length;

          if (this.summaryData.lastInvoice != null) {
            this.lastInvoiceCharge =
              this.summaryData.lastInvoice.totalCharge.toFixed(2);

            this.linkToLastInvoiceNumber =
              "/table/invoice_line/i" +
              this.summaryData.lastInvoice.invoiceNumber;
            this.lastInvoiceDateString = this.buildDateString(
              this.summaryData.lastInvoice.invoiceDate.dayOfMonth,
              this.summaryData.lastInvoice.invoiceDate.monthValue,
              this.summaryData.lastInvoice.invoiceDate.year
            );
          } else {
            this.lastInvoiceDateString = "00/00/0000";
          }

          for (var x of this.summaryData.billedCallPriceByClassType) {
            if (x.sumSpBilledCallPrice > 0) {
              this.chartOptions.labels.push(x.callClassDescription);
              this.series.push(x.sumSpBilledCallPrice);
              this.currentSpend += x.sumSpBilledCallPrice;
            }
          }

          if (this.currentSpend == 0) {
            this.chartOptions.labels = [];
            this.series = [];
            this.chartOptions.labels.push("No Out Of Bundle Spend");
            this.series.push(0.00000001);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    this.getDashboard();

    var element = document.querySelector("html");

    element.classList.remove("disable-scroll");
  },
};
</script>